import { render, staticRenderFns } from "./LegalAdvice.vue?vue&type=template&id=fcc2c454&scoped=true"
import script from "./LegalAdvice.vue?vue&type=script&lang=js"
export * from "./LegalAdvice.vue?vue&type=script&lang=js"
import style0 from "./LegalAdvice.vue?vue&type=style&index=0&id=fcc2c454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc2c454",
  null
  
)

export default component.exports